import { Injectable } from '@angular/core';
import { HttpRequest } from '@angular/common/http';

interface CacheEntry {
  url: string;
  body: any;
  response: any;
  lastUpdated: number;
}

@Injectable({
  providedIn: 'root'
})
export class RequestCacheService {
  private cache = new Map<string, CacheEntry>();
  private cacheExpiration = 300000; // 5 minutes in milliseconds

  getCacheKey(url: string, body: any): string {
    // Create a cache key based on the URL and request body
    return JSON.stringify({ url, body });
  }

  setCache(url: string, body: any, response: any): void {
    const cacheKey = this.getCacheKey(url, body);
    this.cache.set(cacheKey, {
      url: url,
      body: body,
      response,
      lastUpdated: Date.now()
    });
  }

  getFromCache(url: string, request: any): any | null {
    const cacheKey = this.getCacheKey(request.url, request);
    const cacheEntry = this.cache.get(cacheKey);

    if (cacheEntry) {
      const isExpired = Date.now() - cacheEntry.lastUpdated > this.cacheExpiration;
      if (isExpired) {
        this.cache.delete(cacheKey);
        return null;
      }
      return cacheEntry.response;
    }
    return null;
  }

  clearCache(): void {
    this.cache.clear();
  }
}
